import { Backdrop } from './Backdrop';
import { MessageBox } from './MessageBox';

export class CongratsMessageForPrizes {
    private message;
    private backdrop;
    constructor(scene, gameWidth, gameHeight, points) {
        this.backdrop = new Backdrop(scene);
        console.log(points);
        if (points !== '0') {
            this.message = new MessageBox(
                scene,
                gameWidth * 0.8,
                gameHeight * 0.75,
                [
                  {
                    xPos: 250,
                    yPos:250,
                    text: "CONGRATULATIONS!",
                    fontSize: '35px',
                    fontStyle: 'bold',
                    center:"1",
                    color: "#OOO"
                  },
                  {
                    xPos: 250,
                    yPos:325,
                    text: "YOU WON",
                    center:"1",
                    fontSize: '25px',
                    color: "#OOO"},
                  {
                    xPos: 250,
                    yPos:400,
                    text: scene.getPrizeAmount(),
                    center:"1",
                    fontSize: '50px',
                    color: "#OOO"},
                  {
                    xPos: 250,
                    yPos:475,
                    text: scene.getEntryCode(),
                    center:"1",
                    fontSize: '25px',
                    color: "#OOO"},
                  {
                    xPos: 40,
                    yPos:525,
                    text: "To redeem, take your $3 Super Crossword Bonus\nEdition ticket to a BCLC Lottery Retailer. You do not\nneed to bring a print out or a screen shot of your\ndigital win. The retailer will scan your ticket to\nvalidate and pay out any wins - this includes prizes\nwon on the digital game and/or prizes won by\nscratching the ticket.",
                    fontSize: '21px',
                    color: "#OOO"},
                ],
                [
                  { name: 'play-prizes', method: this.quit, width: 270, height: 70, x: 300, y: 775 },
                  { name: 'play-fun', method: this.replayFun, width: 270, height: 70, x: 300, y: 875 }
                ],
                [
                    { width: 350, height: 160, name: 'branding', x: 0.5, y: 0.13 },


                ],
                null,
                'resultsbackground'

            );
        } else {
            this.message = new MessageBox(
                scene,
                gameWidth * 0.8,
                gameHeight * 0.65,
                [

                ],
                [
                    { name: 'next', method: this.quit, width: 240, height: 110, x: 300, y: 750 }
                ],
                [
                    { width: 350, height: 160, name: 'branding', x: 0.5, y: 0.13 },
                    { width: 600, height: 160, name: 'sorry', x: 0.5, y: 0.33 },
                    { width: 400, height: 250, name: 'not-a-winner', x: 0.5, y: 0.6 }

                ],
                null,
                'resultsbackground'

            );
        }
  }

  public quit = () => {
    this.backdrop.destroy();
    this.message.destroy();
    // @ts-ignore
    if (typeof PblInterface !== 'undefined') {
      // @ts-ignore
      PblInterface.game.exit();
    } else {
      window._po_gm.end();
    }
  };

  public replayFun = () => {
    this.backdrop.destroy();
    this.message.destroy();
    // @ts-ignore
    if (typeof PblInterface !== 'undefined') {
      // @ts-ignore
      PblInterface.game.fun = true;
      // @ts-ignore
      PblInterface.game.replay();
    } else {
      window._po_gm.replay();
    }
    // window.location.reload();
  };
}
